import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src716261501/src/github.com/bitstone/offerz-nextjs/src/app/[lang]/(main)/brands/[id]/content.tsx");
